import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
    selectAllHolidayRequests,
    selectPage,
    selectRowsPerPage,
    getRequesting,
    selectPermissions,
} from "./selectors";
import {
    getReports,
    setPage,
    setRowsPerPage,
    setHolidayRequestStatus,
} from "./actions";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
import {
    IconButton,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    TablePagination,
} from "@material-ui/core";

import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import { Edit as EditIcon } from "@material-ui/icons";
import EditHolidayRequestModal from "./EditHolidayRequestModal";
import { Modal, ModalBody, Spinner } from "reactstrap";

class HolidayRequestManager extends Component {
    constructor(props) {
        super(props);
        props.getReports();
        this.state = {
            openEditModal: false,
            currentRequestToEdit: false,
            reason: "",
        };
    }

    callbackFunction = (childData) => {
        this.setState({ reason: childData });
    };

    render() {
        const { holidayRequests, rowsPerPage, page } = this.props;

        return (
            <Fragment>
                <StyledCard>
                    <StyledHeader>
                        <Typography variant="h5">Holiday Request</Typography>
                    </StyledHeader>
                    <StyledContent>
                        <StyledViewContainer>
                            <Modal
                                isOpen={this.props.requesting}
                                style={{ maxWidth: "00px" }}
                            >
                                <ModalBody>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            paddingTop: "3em",
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: "white",
                                                width: "fit-content",
                                                display: "inline-block",
                                                padding: "2em",
                                            }}
                                        >
                                            <Spinner
                                                style={{
                                                    height: 100,
                                                    width: 100,
                                                    background: "white",
                                                }}
                                                color="primary"
                                            />
                                            <Typography
                                                style={{
                                                    textAlign: "center",
                                                    marginTop: 15,
                                                    color:
                                                        "rgba(0, 0, 0, 0.87)",
                                                    fontWeight: "bolder",
                                                    fontSize: 20,
                                                }}
                                                variant="body2"
                                            >
                                                Processing...
                                            </Typography>
                                        </div>
                                    </div>
                                    }
                                </ModalBody>
                            </Modal>

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TablePagination
                                            colSpan={12}
                                            ActionsComponent={
                                                TablePaginationHelper
                                            }
                                            count={
                                                holidayRequests === false
                                                    ? 0
                                                    : holidayRequests.length
                                            }
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={(event, page) =>
                                                setPage(page)
                                            }
                                            onChangeRowsPerPage={(event) =>
                                                setRowsPerPage(
                                                    event.target.value
                                                )
                                            }
                                            rowsPerPageOptions={[50, 100]}
                                        />
                                    </TableRow>
                                    <TableRow>
                                        <TableHeadCell text="User" />
                                        <TableHeadCell text="User Email" />
                                        <TableHeadCell text="Date of Request" />
                                        <TableHeadCell text="Date From " />
                                        <TableHeadCell text="Date To" />
                                        <TableHeadCell text="Total Days" />
                                        <TableHeadCell text="Reason" />
                                        <TableHeadCell text="Approved" />
                                        <TableHeadCell text="Reason for Declining" />
                                        <TableHeadCell text="View" />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {holidayRequests &&
                                        holidayRequests.map(
                                            (request, index) => {
                                                return (
                                                    <TableRow key={index}>
                                                        <TableBodyCell
                                                            text={
                                                                request.employee_name
                                                            }
                                                        />
                                                        <TableBodyCell
                                                            text={
                                                                request.user_email
                                                            }
                                                        />
                                                        <TableBodyCell
                                                            text={
                                                                request.timestamp
                                                            }
                                                        />
                                                        <TableBodyCell
                                                            text={
                                                                request.absence_date_from
                                                            }
                                                        />
                                                        <TableBodyCell
                                                            text={
                                                                request.absence_date_to
                                                            }
                                                        />
                                                        <TableBodyCell
                                                            text={
                                                                request.absence_total_days
                                                            }
                                                        />
                                                        <TableBodyCell
                                                            text={
                                                                request.type_of_absence
                                                            }
                                                        />
                                                        <TableCell
                                                            style={{
                                                                textAlign:
                                                                    "center",
                                                            }}
                                                        >
                                                            <Typography
                                                                style={{
                                                                    color:
                                                                        request.manager_approval ===
                                                                        "approved"
                                                                            ? "green"
                                                                            : request.manager_approval ===
                                                                              "pending"
                                                                            ? "orange"
                                                                            : "red",
                                                                }}
                                                                variant="body2"
                                                            >
                                                                <b>
                                                                    {" "}
                                                                    {request.manager_approval ===
                                                                    "approved"
                                                                        ? "Approved"
                                                                        : request.manager_approval ===
                                                                          "pending"
                                                                        ? "Pending"
                                                                        : "Declined"}
                                                                </b>
                                                            </Typography>
                                                        </TableCell>
                                                        <TableBodyCell
                                                            text={
                                                                request.reason
                                                            }
                                                        />
                                                        <TableCell>
                                                            {this.props
                                                                .permissions && (
                                                                <IconButton
                                                                    onClick={() =>
                                                                        this.setState(
                                                                            {
                                                                                openEditModal: true,
                                                                                currentRequestToEdit: request,
                                                                            }
                                                                        )
                                                                    }
                                                                    style={{
                                                                        color:
                                                                            "indigo",
                                                                        border:
                                                                            "1px solid indigo",
                                                                    }}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }
                                        )}
                                </TableBody>
                            </Table>
                        </StyledViewContainer>
                        <StyledViewContainer>
                            <EditHolidayRequestModal
                                isOpen={this.state.openEditModal}
                                closeModal={() =>
                                    this.setState({ openEditModal: false })
                                }
                                request={this.state.currentRequestToEdit}
                                parentCallback={this.callbackFunction}
                                setStatus={(status) => {
                                    this.props.setHolidayRequestStatus(
                                        this.state.currentRequestToEdit
                                            .user_uid,
                                        status,
                                        this.state.currentRequestToEdit
                                            .timestamp
                                    );
                                }}
                            />
                        </StyledViewContainer>
                    </StyledContent>
                </StyledCard>
            </Fragment>
        );
    }
}
const TableHeadCell = (props) => {
    return (
        <TableCell style={{ textAlign: "center" }}>
            <Typography variant="body2">
                <b>{props.text}</b>
            </Typography>
        </TableCell>
    );
};
const TableBodyCell = (props) => {
    return (
        <TableCell style={{ textAlign: "center" }}>
            <Typography variant="body2">{props.text}</Typography>
        </TableCell>
    );
};
export default connect(
    (store) => {
        return {
            holidayRequests: selectAllHolidayRequests(store),
            page: selectPage(store),
            rowsPerPage: selectRowsPerPage(store),
            requesting: getRequesting(store),
            permissions: selectPermissions(store),
        };
    },
    { getReports, setHolidayRequestStatus, setRowsPerPage, setPage }
)(HolidayRequestManager);
